import React, { useState, useEffect, Link } from 'react';
import axios from 'axios';
import { Cookies } from '../../index.js';
import { useNavigate } from 'react-router-dom';
import { alert_error, alert_success } from '../../AppContext';
import AdSense from 'react-adsense';
import { RingLoader } from "react-spinners";
function Editshop() {
  const [inputcaption, setinputcaption] = useState('');
  const [social, setSocial] = useState('');
  const [loading, setloading] = useState(false);

  const [damoshop, setdamoshop] = useState(Cookies.get('damoshop'));
  const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
  const [thanhcong2, setthanhcong2] = useState('');
  const [nutxuly, setnutxuly] = useState(0);
  const [chedo, setchedo] = useState('');
  const [content, setcontent] = useState('');
  const navigate = useNavigate();
  const [options, setoptions] = useState([
    {
      id: '', stt: '', name: 'Chọn 1 thể loại của bạn',
      money: '', status: 'show', content: '', servicecode: ''
    }
  ]);
  const [options2, setoptions2] = useState([
    {
      id: '', stt: '', name: 'Chọn 1 dịch vụ của bạn',
      money: '', status: 'show', content: '', servicecode: ''
    }
  ]);
  const handleOptionChange2 = (event) => {
    const selectedOption = event.target.value;

    setchedo(selectedOption);
    console.log(selectedOption);
  }
  const handleOptionChange = (event) => {
    setloading(true);
    const selectedOption = event.target.value;
    const selectedOptionok = options.find((option) => option.id == selectedOption);
    console.log(selectedOptionok);
    console.log(selectedOptionok.option);
    const domain = window.location.hostname;
    //   setcontent(selectedOptionok.category);
    axios
      .post('https://hust.media/getservice/service5.php', {
        chedo: 'service',
        domain: domain,
        category: selectedOptionok.option
      })
      .then(response => laydichvu(response), setloading(false))
      .catch(error => console.log(error), setloading(false))
    // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
  }
  function laydichvu(response) {
    const arr1 = [
      {
        id: '', stt: '', name: 'Chọn 1 dịch vụ mà bạn cung cấp dịch vụ',
        money: '', status: 'show', content: '', servicecode: ''
      }
    ];

    const arr2 = response.data;

    setoptions2(arr1.concat(arr2));
  }
  function gopdulieu(response) {
    const arr1 = [
      {
        id: '', stt: '', name: 'Chọn 1 thể loại mà bạn cung cấp dịch vụ',
        money: '', status: 'show', content: '', servicecode: ''
      }
    ];

    const arr2 = response.data;

    setoptions(arr1.concat(arr2));

  }
  function laydulieu() {
    const dfsdfsdf = Cookies.get('damoshop');
    console.log(dfsdfsdf);
    setdamoshop(dfsdfsdf);

    if (damoshop == 'ok') {
      axios
        .post('https://hust.media/getservice/service5.php', {
          chedo: 'category',
          category: 'web'
        })
        .then(response => gopdulieu(response))
        .catch(error => console.log(error))
    }
    else {
      setTimeout(() => {
        navigate('/reactapp/baohiem');
      }, 200);
    }
    setTimeout(() => {
      const dsfsdfsfd = Cookies.get('damoshop');
      console.log(dsfsdfsfd);
      setdamoshop(dsfsdfsfd);
      if (dsfsdfsfd == 'ok') {
      }
      else {
        setTimeout(() => {
          navigate('/reactapp/baohiem');
        }, 100);
      }
    }, 2100);



  }
  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder('đặt tiếp luôn nào')
    setnutxuly(0);
    if (status == 0) {
      alert_error(info.message);
    }
    else if (status == 1) {
      alert_success(info.message);
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  function handleSubmit(event) {
    setnutxuly(0);
    const apikey = Cookies.get('apikey');
    event.preventDefault();

    setnutxuly(1);
    setnutorder('Please wait a moment 😊');
    if (!inputcaption) {
      alert_error('Please điền đầy đủ thông tin')
      setnutxuly(0);
      setnutorder('điền đủ thông tin');
      return
    }
    axios
      .post('https://hust.media/nosql/addservice.php', {
        key: apikey,
        caption: inputcaption,
        chedo: 'shop',
        theloai: 'edit',
        service: chedo
      })
      .then(response => (testFunction(response)))
      .catch(error => console.log(error))

  }

  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };

  useEffect(() => {
    // Thực hiện các hành động liên quan đến giá trị đã chọn tại đây
  }, [social]);
  useEffect(() => {
    laydulieu();


  }, []);


  return (
    <>      <div className="max-h-16">
      <div className="cards">
        <AdSense.Google
          client="ca-pub-4574266110812955"
          slot="1627514116"
          style={{ display: 'block', height: 50 }}
          format=""
        /> </div>
    </div>
      {loading ? (
        <div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" />{" "}
        </div>
      ) : (<div>
            <form className="add-form">
              <div className="form-control">
                <label>Chọn thể loại mặt hàng của bạn</label>
                <select
                  id="countries1"
                  className="selectpicker sp1 form-control"
                  onChange={handleOptionChange}
                >
                  {options.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
                <label>Chọn dịch vụ mà bạn cung cấp</label>
                <br />
                <select
                  id="countries2"
                  className="selectpicker sp2 form-control"
                  onChange={handleOptionChange2}
                  value={chedo}
                >
                  {options2.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>

                <div v-if="cocaption" >
                  <label>Tạo tiêu đề ngọt ngào cho bài đăng bán hàng của bạn: (Tiêu đề dễ thương và thông tin rõ ràng cho sản phẩm của bạn)</label>
                  <br />
                  <div className="input-group flex-nowrap">
                    <span className="input-group-text" id="addon-wrapping">Captions</span>
                    <input
                      onChange={e => setinputcaption(e.target.value)}
                      value={inputcaption} type="text" className="form-control"
                      placeholder="VD: DỊCH VỤ FACEBOOK (FOLLOW-LIKE-CMT)-giá rẻ uy tín" aria-label="inputcaption" name="inputcaption" aria-describedby="addon-wrapping">
                    </input>    </div>

                </div>
                <div className="text-sm">     Phí sửa shop là 100 Coins -.-   </div>
              </div>

              <p>
                {content}
              </p>


              <button disabled={nutxuly} onClick={handleSubmit}
                className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white'>
                <div className='flex items-center justify-between flex-1'>
                  {nutxuly == 1 &&
                    <div className="spinner-border" role="status">

                    </div>}


                  <span className='text-lg font-medium text-white'>
                    {nutorder} </span>
                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                </div>
              </button>
            </form>
            {thanhcong2 != '' && <>
              <div className="relative py-3 sm:max-w-xl sm:mx-auto">
                <div className="flex flex-col items-center justify-center py-2">
                  <div className="absolute inset-0 bg-gradient-to-r from-indigo-200 to-purple-600 shadow-lg transform rotate-6 rounded-3xl">

                  </div>
                  <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
                    <h2 className="text-3xl text-break font-bold">
                      kết quả {thanhcong2} </h2></div></div></div>
              <button onClick={() => saochep(thanhcong2)} className="bg-pink-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
                Sao chép
              </button> </>}

     
    
        <br></br>
      </div>)}  </>
  )
}

export default Editshop;